import { render, staticRenderFns } from "./input-doc-date.vue?vue&type=template&id=2a9c81c6"
import script from "./input-doc-date.vue?vue&type=script&lang=js"
export * from "./input-doc-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports